export default {
  namespaced: true,
  actions: {
    async trucks ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/carriers', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async lines ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/shipments', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async incidences ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/incidences', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async incidenceDetails ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/incidences_reason', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async machines ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/task_machinery', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async taskUsers ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/task_user', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async taskWorktime ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/task_worktime', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    },
    async logisticsIndex ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/metrics/logistic_index', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          return response.results
        })
        .catch(error => { throw error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/metrics.js